import { BottomNav } from '@/components/BottomNav';

// Wraps screen content inside the centered mobile frame with bottom nav.
export const AppLayout = ({ children, showNav = true }) => {
  return (
    <div className="app-canvas">
      <div className="app-shell app-canvas">
        <div className="px-4 pb-28 pt-3">{children}</div>
        {showNav ? <BottomNav /> : null}
      </div>
    </div>
  );
};
